// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as StockActivityKind from "./StockActivityKind.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityQuantity from "./StockActivityQuantity.res.js";
function StockActivityQuantityTableCell(props) {
  let kind = props.kind;
  let newrecord = {
    ...Stylex.props({
      color: StockActivityKind.toColor(kind),
      font: `normal 600 15px "Libre Franklin"`
    })
  };
  return JsxRuntime.jsx("span", (newrecord.children = StockActivityQuantity.format(kind, props.capacityPrecision, props.capacityUnit, props.value), newrecord));
}
let make = React.memo(StockActivityQuantityTableCell);
export { make };
/* make Not a pure module */